import { makeStyles } from '@material-ui/core/styles';
import { PrimaryColors, TextColors, Theme } from '@/utils/constants';

const lightTheme = {
  root: {
    color: PrimaryColors.main,
  },
};
const darkTheme = {
  root: {
    color: TextColors.light,
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(3),
      },
    },
  }),
  { name: 'GenPressCenterHeader' },
);

export default useStyles;
